<template>
  <div
    class="tab-pane fade in"
    :class="{ active: vx_activeTab === 'instant' }"
    id="instant"
    role="tabpanel"
  >
    <div class="table-responsive">
      <table
        class="table table-striped jambo_table bulk_action fixed-header-table"
      >
        <thead class="fixed-header">
          <tr class="headings">
            <th
              v-for="head in HEAD"
              :key="head"
              class="column-title word_center"
            >
              {{ head }}
            </th>
            <th class="bulk-actions" colspan="7">
              <a class="antoo">
                Bulk Actions (
                <span class="action-cnt"></span>
                )
                <i class="fa fa-chevron-down"></i>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(order, idx) in vx_instantList">
            <tr
              :key="order.id"
              :class="{
                even: idx % 2 == 0,
                odd: idx % 2 != 0,
              }"
              class="pointer"
              style="color: #000000"
            >
              <td class="word_center">{{ order.id }}</td>
              <td class="word_center">
                {{ reserveAfterStr(order.passengerNote) }}
              </td>
              <td class="word_center">
                <template v-if="order.callNumber">
                  <div>{{ order.callNumber.split(' ')[0] }}</div>
                  <div>{{ order.callNumber.split(' ')[1] }}</div>
                </template>
              </td>
              <td class="word_center">{{ order.createdAt }}</td>
              <td class="word_center">
                <el-tooltip
                  class="customer-phone-tooltip"
                  effect="dark"
                  :content="order.passengerNote"
                  placement="top-start"
                >
                  <span>
                    {{
                      order.callMethod === '客服'
                        ? order.customerPhone
                        : order.passenger_phone
                    }}
                  </span>
                </el-tooltip>
              </td>
              <td class="word_center">
                {{
                  order.callMethod === '客服'
                    ? order.callMethod + '/' + order.serviceName
                    : order.callMethod
                }}
              </td>
              <td class="word_center">{{ order.type }}</td>
              <td class="word_left">{{ order.onLocation }}</td>
              <td class="word_center">
                <!--派車單狀態-->
                <el-tooltip
                  v-if="order.result && order.cancelReason !== ''"
                  placement="top"
                >
                  <div slot="content" style="font-size: 1.8rem">
                    {{ order.cancelReason }}
                  </div>
                  <span>已取消</span>
                </el-tooltip>
                <!-- {{ order.result }} -->
                <template
                  v-if="
                    order.result !== '成功' &&
                    order.result !== '司機已載客' &&
                    order.cancelReason === '' &&
                    order.callNumber
                  "
                >
                  <el-button
                    :loading="isLoading && loadingOrderId === order.id"
                    @click="onUpdateArriveTime(order.id, order.result)"
                    type="text"
                  >
                    到達時間
                    {{ getArriveTime(order.id, order.result) }}
                  </el-button>
                </template>
              </td>
              <td class="word_center">{{ order.systemError }}</td>
              <td class="last">
                <router-link
                  class="red_textcolor"
                  :to="{
                    name: 'transactionDetail',
                    params: { id: order.id, task: taskStr },
                  }"
                >
                  檢視
                </router-link>
                <el-button size="small" @click="onRecord(order.id)">
                  活動紀錄
                </el-button>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <!--頁籤-->
      <el-row>
        <el-col :offset="10">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="onPageChange"
            :current-page="vx_instantPaging.currentPage"
            :page-count="vx_instantPaging.totalPages"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { Notification } from 'element-ui'
import { reqUpdateArriveTime } from '@/api/transaction'
import { instant } from '@/constants/tableHead'
import { instantPick as PICK } from '@/constants/select'

export default {
  data() {
    return {
      isLoading: false,
      loadingOrderId: null,
      arriveTimeList: [],
    }
  },
  computed: {
    ...mapState('transaction', {
      vx_activeTab: 'activeTab',
      vx_instantList: 'instantList',
      vx_instantPaging: 'instantPaging',
      vx_instantPick: 'instantPick',
    }),
    taskStr() {
      const pickObj = PICK.find((pick) => pick.id === this.vx_instantPick)
      if (pickObj) {
        return pickObj.task
      }
      return ''
    },
  },
  methods: {
    ...mapMutations('transaction', {
      vx_setInstantPagingCurrentPage: 'setInstantPagingCurrentPage',
    }),
    ...mapActions('transaction', {
      vx_fetchList: 'fetchList',
    }),
    onRecord(id) {
      this.$router.push({
        name: 'activityRecord',
        query: { id: id, type: '立即單' },
      })
    },
    reserveAfterStr(note) {
      if (note.indexOf('||預約時間') > 0) {
        return note.split('||預約時間:')[1]
      }
      return ''
    },
    onPageChange(page) {
      this.vx_setInstantPagingCurrentPage(page)
      this.vx_fetchList()
    },
    async onUpdateArriveTime(orderId, orderResult) {
      try {
        this.isLoading = true
        this.loadingOrderId = orderId
        const { result } = await reqUpdateArriveTime(orderId)
        const idx = this.arriveTimeList.findIndex(({ id }) => id === orderId)
        if (idx >= 0) {
          this.arriveTimeList[idx].duration = result.duration
        } else {
          this.arriveTimeList.push({ id: orderId, duration: result.duration })
        }
        /* 若是預計到達時間為0，則須重新更新訂單列表 */
        if (result.duration === '0') {
          this.vx_fetchList()
        } else {
          this.getArriveTime(orderId, orderResult)
        }
      } catch (e) {
        console.error(e)
        Notification({
          type: 'error',
          message: '取得最新到達時間失敗',
        })
      } finally {
        this.isLoading = false
        this.loadingOrderId = null
      }
    },
    getArriveTime(orderId, orderResult) {
      const item = this.arriveTimeList.find(({ id }) => id === orderId)
      /* 如果訂單
       * 1. 可取得到達時間
       * 2. 且到達時間不是0
       * 3. 且訂單狀態並非成功
       * 若符合上述的三個條件，則回傳到達時間否則回傳空字串
       */
      if (
        !item ||
        item.duration === '0' ||
        orderResult === '成功' ||
        orderResult === '司機已載客'
      ) {
        return ''
      } else {
        return item.duration
      }
    },
  },
  created() {
    this.HEAD = instant
  },
}
</script>

<style lang="scss" scoped>
.el-button {
  padding-top: 0;
}

.customer-phone-tooltip:hover {
  cursor: pointer;
}

.table-responsive {
  position: relative;
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.fixed-header-table {
  width: 100%;
  table-layout: fixed;
}

.fixed-header {
  position: sticky;
  top: 0;
  z-index: 10;
}

.fixed-header th {
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.1);
  background: rgba(73, 87, 96, 1);
}
</style>



// WEBPACK FOOTER //
// src/pages/transaction/components/Instant.vue